// 作品信息
const state = {
  worksName: '',
  worksId: '',
  worksProjectId: '',
  templateStyle: '',
  templateId: '',
  pptDraftId: '',
  userId: '',
  loadType: '',
  saveDraftTime: '',
  worksSaveState: 'notSaved',
  templateIds: []
}

//获取数据 getters
const getters = {
  WorksName: state => state.worksName,
  WorksId: state => state.worksId,
  WorksProjectId: state => state.worksProjectId || location.hash.replace('#', '').replace('/', ''),
  WorksTemplateStyle: state => state.templateStyle,
  WorksTemplateId: state => state.templateId,
  PPTDraftId: state => state.pptDraftId,
  getUserId: state => state.userId,
  LoadType: state => state.loadType,
  SaveDraftTime: state => state.saveDraftTime,
  WorksSaveState: state => state.worksSaveState,
  WorksTemplateIds: state => state.templateIds
}

//修改数据 mutations
const mutations = {
  save_WorksName(state, data) {
    state.worksName = data;
  },
  save_WorksId(state, data) {
    state.worksId = data;
  },
  save_WorksProjectId(state, data) {
    state.worksProjectId = data;
  },
  save_TemplateStyle(state, data) {
    state.templateStyle = data;
  },
  save_TemplateId(state, data) {
    state.templateId = data;
  },
  save_PPTDraftId(state, data) {
    state.pptDraftId = data;
  },
  save_Works(state, data) {
    state = {
      ...state,
      ...data
    }
  },
  save_UserId(state, data) {
    state.userId = data;
  },
  save_LoadType(state, data) {
    state.loadType = data;
  },
  set_SaveDraftTime(state, data) {
    state.saveDraftTime = data;
  },
  set_WorksSaveState(state, data) {
    state.worksSaveState = data;
  },
  add_WorksTemplateId(state, data) {
    const hasItem = state.templateIds.includes(data);
    if (!hasItem) {
      state.templateIds.push(data);
    }
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/works.js